<template>
<v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
  <v-dialog v-model="permitted_dialog" max-width="400px">
    <v-card>
      <v-card-text>
        <div class="text-center">
          <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
          <p>{{message}}</p>
          <v-progress-circular
            :size="70"
            :width="2"
            :value="100"
            color="error"
            class="mb-4 mr-4"
          >
            <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
          </v-progress-circular>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</v-container>
<v-container v-else v-show="permitted != null" class="pt-0" fluid>
  <v-snackbar
    :value="showMessage()"
    multi-line
    color="#686868"
    top
    
  >
    {{message}}
  </v-snackbar>
  <v-card flat>
  <v-toolbar dense flat color="#2A353D">
    <v-toolbar-title class="white--text subtitle-1 font-weight-normal">Custodians</v-toolbar-title>
    <v-spacer/>
    <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
    <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>
  </v-toolbar>
  </v-card>
  <v-data-table
    disable-pagination
    hide-default-footer
    :height="520"
    fixed-header
    :headers="headers"
    :items="confirmedCustodians ? allCustodians : allCustodians.filter(a => a.CheckerID === 0)"
    :search="search"
    sort-by="MakeDate"
    sort-desc
    class="elevation-12 mt-2"
    @current-items="getFiltered"
  >

    <template v-slot:top >
      <v-dialog persistent v-model="rejectionDialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="subtitle-1 grey--text">Choose a reason for this rejection</span>
          </v-card-title>

          <v-card-text>
            <v-select
              filled dense
              v-model="RejectionStatus"
              :items="allRejectionReasons.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
              item-text="RejectionReasonDescription"
              item-value="RejectionReasonID"
              label="Rejection Reasons"
            ></v-select>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="text-right mb-4">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="RejectionStatus = 0; rejectionDialog = false">cancel</v-btn>
              <v-btn class="white--text mr-3" small color="#2A353D" v-if="RejectionStatus !== 0" @click="updateStatus()">
                <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                ok
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="deleteDialog" max-width="350px">
        <v-card>
          <v-card-title>
            <span class="subtitle-1 grey--text text-center ma-4 mx-7">Are you sure you want to DELETE  the selected item?</span>
          </v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="text-right mb-4">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="deleteDialog = false">no</v-btn>
              <v-btn class="white--text mr-3" small color="#2A353D" @click="deleteItem()">
                <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                yes
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-form class="edit rounded-t-xl elevation-6" v-if="create">
        <v-toolbar dense flat color="#DBEFFA">
          <v-toolbar-title class="grey--text subtitle-1 font-weight-normal">Create New Custodian</v-toolbar-title>
          <v-spacer/>
        </v-toolbar>

        <v-stepper class="elevation-0" style="background: #DBEFFA" v-model="e1">
          <v-stepper-header class="elevation-0">
            <v-stepper-step
              :rules="[() => step1_valid]"
              :complete="e1 > 1"
              step="1"
            >
              Profile
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
              :rules="[() => step2_valid]"
              :complete="e1 > 2"
              step="2"
            >
              Contact Details
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
              :rules="[() => step3_valid]"
              :complete="e1 > 3"
              step="3"
            >
            Contacts
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-form ref="step_1" v-model="step1_valid" lazy-validation elevation="12">
                <v-row class="ml-1 mr-1">
                  <v-col>
                    <v-text-field
                      light dense filled
                      color="#2A353D"
                      v-model="custodian.CustodianCode"
                      label="Custodian Code"
                      required
                      :rules="[
                        v => !!v || 'field is required',
                        v => (v && v.length <= 10) || 'field must be less than 10 characters'
                      ]"
                    ></v-text-field>
                    <v-select
                      filled dense
                      v-model="custodian.ProfileType"
                      :items="allProfileTypes.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                      item-text="ProfileType"
                      item-value="ProfileTypeID"
                      label="Profile Type"
                      :rules="TextFieldRules"
                    ></v-select>
                  </v-col>
                  <v-col>
                    <v-text-field
                      light dense filled
                      color="#2A353D"
                      v-model="custodian.CustodianName "
                      label="Custodian Name"
                      required
                      :rules="[
                        v => !!v || 'field is required',
                        v => (v && v.length <= 50) || 'field must be less than 50 characters'
                      ]"
                    ></v-text-field>
                    <v-select
                      filled dense
                      v-model="custodian.CustodianStatusID"
                      :items="allCustodianStatuses.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                      item-text="CustodianStatusCode"
                      item-value="CustodianStatusID"
                      label="Custodian Status"
                      :rules="TextFieldRules"
                    ></v-select>
                  </v-col>
                  <v-col>
                    <v-text-field
                      light dense filled
                      color="#2A353D"
                      v-model="custodian.Cashbook"
                      label="Consolidated Balance"
                      required
                      :rules="TextFieldRules"
                    ></v-text-field>
                    <v-row>
                      <v-col>
                        <v-checkbox
                          v-model="custodian.IsExternal"
                          class="mt-0"
                          label="Is External?"
                          :readonly="view"
                        ></v-checkbox>
                      </v-col>
                      <!-- <v-col>
                        <v-checkbox
                          v-model="custodian.IsTaxable"
                          class="mt-0"
                          label="Is Taxable"
                          :readonly="view"
                        ></v-checkbox>                        
                      </v-col> -->
                    </v-row>
                  </v-col>
                </v-row>
                <span class="d-flex flex-row my-4">
                  <v-spacer/>
                  <v-btn disabled outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-left</v-icon></v-btn>
                  <v-btn class="mx-2" @click="validateStep_1()" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-right</v-icon></v-btn>
                  <v-btn class="white--text" small color="#2A353D" @click="closeCreate()">close</v-btn>
                </span>
              </v-form>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-form ref="step_2" v-model="step2_valid" lazy-validation elevation="12">
                <v-row class="ml-1 mr-1">
                  <v-col>
                    <v-card class="pa-5 pt-2">
                      <span class="caption">Physical Address</span>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="custodian.Physical_Address_1"
                        required
                        :rules="[
                          v => !!v || 'field is required',
                          v => (v && v.length <= 30) || 'field must be less than 30 characters'
                        ]"
                      ></v-text-field>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="custodian.Physical_Address_2"
                        required
                        :rules="[
                          v => v ? (v && v.length <= 30) || 'field must be less than 30 characters' : null
                        ]"
                      ></v-text-field>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="custodian.Physical_Address_3"
                        required
                        :rules="[
                          v => v ? (v && v.length <= 30) || 'field must be less than 30 characters' : null
                        ]"
                      ></v-text-field>
                      <v-select
                        filled dense
                        v-model="custodian.Physical_CountryID"
                        :items="allCountries.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                        item-text="CountryName"
                        item-value="CountryId"
                        label="Country"
                        :rules="TextFieldRules"
                      ></v-select>
                      <v-select
                        filled dense
                        v-model="custodian.Physical_CityID"
                        :items="allCities.filter(a => a.CountryId == custodian.Physical_CountryID && a.CheckerID != 0 && a.RejectionID == 0)"
                        item-text="City"
                        item-value="CityID"
                        label="City"
                        :rules="TextFieldRules"
                      ></v-select>
                    </v-card>
                  </v-col>
                  <v-col>
                     <v-card class="pa-5 pt-2">
                      <span class="caption">Postal Address</span>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="custodian.Postal_Address_1"
                        required
                        :rules="[
                          v => !!v || 'field is required',
                          v => (v && v.length <= 30) || 'field must be less than 30 characters'
                        ]"
                      ></v-text-field>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="custodian.Postal_Address_2"
                        required
                        :rules="[
                          v => v ? (v && v.length <= 30) || 'field must be less than 30 characters' : null
                        ]"
                      ></v-text-field>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="custodian.Postal_Address_3"
                        required
                        :rules="[
                          v => v ? (v && v.length <= 30) || 'field must be less than 30 characters' : null
                        ]"
                      ></v-text-field>
                      <v-select
                        filled dense
                        v-model="custodian.Postal_CountryID"
                        :items="allCountries.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                        item-text="CountryName"
                        item-value="CountryId"
                        label="Country"
                        :rules="TextFieldRules"
                      ></v-select>
                      <v-select
                        filled dense
                        v-model="custodian.Postal_CityID"
                        :items="allCities.filter(a => a.CountryId == custodian.Postal_CountryID && a.CheckerID != 0 && a.RejectionID == 0)"
                        item-text="City"
                        item-value="CityID"
                        label="City"
                        :rules="TextFieldRules"
                      ></v-select>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-text-field
                      light dense filled
                      color="#2A353D"
                      v-model="custodian.Telephone"
                      label="Cell/Telephone"
                      required
                      type="number"
                      :rules="[
                        v => !!v || 'field is required',
                        v => (v && v.length <= 30) || 'field must be less than 30 characters'
                      ]"
                    ></v-text-field>
                    <v-text-field
                      light dense filled
                      color="#2A353D"
                      v-model="custodian.Email"
                      label="Email"
                      required
                      :rules="emailRules"
                    ></v-text-field>
                    <v-text-field
                      light dense filled
                      color="#2A353D"
                      v-model="custodian.Fax"
                      label="Fax"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <span class="d-flex flex-row my-4">
                  <v-spacer/>
                  <v-btn @click="e1 = 1" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-left</v-icon></v-btn>
                  <v-btn class="mx-2" @click="validateStep_2()" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-right</v-icon></v-btn>
                  <v-btn class="white--text" small color="#2A353D" @click="closeCreate()">close</v-btn>
                </span>
              </v-form>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-form ref="step_3" v-model="step3_valid" lazy-validation elevation="12">
                <v-data-table
                  :headers="contact_headers"
                  :fixed-header="true"
                  :items="custodian.contacts"
                  disable-pagination
                  hide-default-footer dense
                  class="elevation-12 my-allocations-table mt-3"
                >

                  <template v-slot:top >
                    <v-toolbar dense flat>
                      <v-toolbar-title class="grey--text caption font-weight-normal">Contacts</v-toolbar-title>
                      <v-spacer/>
                      <v-btn class="text-right" @click="NewContact(custodian.contacts)" x-small dark outlined fab color="#2A353D">
                        <v-icon small >mdi-plus</v-icon>
                      </v-btn>
                    </v-toolbar>
                  </template>

                  <template v-slot:item.Contact="{ item }">
                    <v-text-field
                      v-model="item.Contact"
                      label="Name"
                      :rules="TextFieldRules"
                      single-line
                    ></v-text-field>
                  </template>

                  <template v-slot:item.ContactNumber="{ item }">
                    <v-text-field
                      v-model="item.ContactNumber"
                      label="Cell/Telephone"
                      :rules="TextFieldRules"
                      type="number"
                      single-line
                    ></v-text-field>
                  </template>

                  <template v-slot:item.Email="{ item }">
                    <v-text-field
                      v-model="item.Email"
                      label="Email"
                      :rules="emailRules"
                      single-line
                    ></v-text-field>
                  </template>

                  <template v-slot:item.IsPrimaryContact="{ item }">
                    <v-simple-checkbox
                      v-model="item.IsPrimaryContact"
                    ></v-simple-checkbox>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-icon small @click="removeContact(item, custodian.contacts)">mdi-close</v-icon>
                  </template>
                </v-data-table>

                <span class="d-flex flex-row my-4 pt-7">
                  <v-spacer/>
                  <v-btn @click="e1 = 2" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-left</v-icon></v-btn>
                  <v-btn class="mx-2" disabled outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-right</v-icon></v-btn>
                  <v-btn class="white--text" small color="#2A353D" @click="closeCreate()">close</v-btn>
                  <v-btn class="white--text ml-3" small color="#2A353D" :disabled="!valid" @click="createNew()">
                    <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    submit
                  </v-btn>
                </span>
              </v-form>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-form>

      <v-form class="edit rounded-t-xl elevation-6" ref="form" v-model="valid" lazy-validation v-if="edit" >
        <v-toolbar dense flat color="#DBEFFA">
          <v-toolbar-title class="d-flex flex-row grey--text subtitle-1 font-weight-normal">Custodian: {{currentCustodian.CustodianCode.toUpperCase()}}</v-toolbar-title>
            <v-spacer/>
            <span class="mr-2 grey--text caption font-weight-normal">Maker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentCustodian.MakerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
            <span v-if="currentCustodian.CheckerID != 0" class="mx-2 grey--text caption font-weight-normal">Checker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentCustodian.CheckerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
            <span class="ml-2 grey--text caption font-weight-normal">Last User: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentCustodian.LastUserID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
        </v-toolbar>

        <v-stepper class="elevation-0" style="background: #DBEFFA" v-model="e1">
          <v-stepper-header class="elevation-0">
            <v-stepper-step
              :rules="[() => step1_valid]"
              :complete="e1 > 1"
              step="1"
            >
              Profile
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
              :rules="[() => step2_valid]"
              :complete="e1 > 2"
              step="2"
            >
              Contact Details
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
              :rules="[() => step3_valid]"
              :complete="e1 > 3"
              step="3"
            >
            Contacts
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-form ref="step_1" v-model="step1_valid" lazy-validation elevation="12">
                <v-row class="ml-1 mr-1">
                  <v-col>
                    <v-text-field
                      light dense filled
                      color="#2A353D"
                      v-model="currentCustodian.CustodianCode"
                      label="Custodian Code"
                      :readonly="view"
                      required
                      :rules="[
                        v => !!v || 'field is required',
                        v => (v && v.length <= 10) || 'field must be less than 10 characters'
                      ]"
                    ></v-text-field>
                    <v-select
                      filled dense
                      v-model="currentCustodian.ProfileType"
                      :items="allProfileTypes.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                      item-text="ProfileType"
                      item-value="ProfileTypeID"
                      label="Profile Type"
                      :readonly="view"
                      :rules="TextFieldRules"
                    ></v-select>
                  </v-col>
                  <v-col>
                    <v-text-field
                      light dense filled
                      color="#2A353D"
                      v-model="currentCustodian.CustodianName "
                      label="Custodian Name"
                      :readonly="view"
                      required
                      :rules="[
                        v => !!v || 'field is required',
                        v => (v && v.length <= 50) || 'field must be less than 50 characters'
                      ]"
                    ></v-text-field>
                    <v-select
                      filled dense
                      v-model="currentCustodian.CustodianStatusID"
                      :items="allCustodianStatuses.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                      item-text="CustodianStatusCode"
                      item-value="CustodianStatusID"
                      label="Custodian Status"
                      :readonly="view"
                      :rules="TextFieldRules"
                    ></v-select>
                  </v-col>
                  <v-col>
                    <v-text-field
                      light dense filled
                      color="#2A353D"
                      v-model="currentCustodian.Cashbook"
                      label="Consolidated Balance"
                      required
                      :readonly="view"
                      :rules="TextFieldRules"
                    ></v-text-field>
                    <v-row>
                      <v-col>
                        <v-checkbox
                          v-model="currentCustodian.IsExternal"
                          class="mt-0"
                          label="Is External?"
                          :readonly="view"
                        ></v-checkbox>
                      </v-col>
                      <!-- <v-col>
                        <v-checkbox
                          v-model="currentCustodian.IsTaxable"
                          class="mt-0"
                          label="Is Taxable"
                          :readonly="view"
                        ></v-checkbox>                        
                      </v-col> -->
                    </v-row>
                  </v-col>
                </v-row>
                <span class="d-flex flex-row my-4">
                  <v-spacer/>
                  <v-btn disabled outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-left</v-icon></v-btn>
                  <v-btn class="mx-2" @click="validateStep_1()" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-right</v-icon></v-btn>
                  <v-btn class="white--text" small color="#2A353D" @click="view = false; closeEdit()">close</v-btn>
                </span>
              </v-form>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-form ref="step_2" v-model="step2_valid" lazy-validation elevation="12">
                <v-row class="ml-1 mr-1">
                  <v-col>
                    <v-card class="pa-5 pt-2">
                      <span class="caption">Physical Address</span>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="currentCustodian.Physical_Address_1"
                        required
                        :readonly="view"
                        :rules="[
                          v => !!v || 'field is required',
                          v => (v && v.length <= 30) || 'field must be less than 30 characters'
                        ]"
                      ></v-text-field>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="currentCustodian.Physical_Address_2"
                        required
                        :readonly="view"
                        :rules="[
                          v => v ? (v && v.length <= 30) || 'field must be less than 30 characters' : null
                        ]"
                      ></v-text-field>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="currentCustodian.Physical_Address_3"
                        required
                        :readonly="view"
                        :rules="[
                          v => v ? (v && v.length <= 30) || 'field must be less than 30 characters' : null
                        ]"
                      ></v-text-field>
                      <v-select
                        filled dense
                        v-model="currentCustodian.Physical_CountryID"
                        :items="allCountries.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                        item-text="CountryName"
                        item-value="CountryId"
                        label="Country"
                        :readonly="view"
                        :rules="TextFieldRules"
                      ></v-select>
                      <v-select
                        filled dense
                        v-model="currentCustodian.Physical_CityID"
                        :items="allCities.filter(a => a.CountryId == currentCustodian.Physical_CountryID && a.CheckerID != 0 && a.RejectionID == 0)"
                        item-text="City"
                        item-value="CityID"
                        label="City"
                        :readonly="view"
                        :rules="TextFieldRules"
                      ></v-select>
                    </v-card>
                  </v-col>
                  <v-col>
                     <v-card class="pa-5 pt-2">
                      <span class="caption">Postal Address</span>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="currentCustodian.Postal_Address_1"
                        required
                        :readonly="view"
                        :rules="[
                          v => !!v || 'field is required',
                          v => (v && v.length <= 30) || 'field must be less than 30 characters'
                        ]"
                      ></v-text-field>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="currentCustodian.Postal_Address_2"
                        required
                        :readonly="view"
                        :rules="[
                          v => v ? (v && v.length <= 30) || 'field must be less than 30 characters' : null
                        ]"
                      ></v-text-field>
                      <v-text-field
                        light dense
                        color="#2A353D"
                        v-model="currentCustodian.Postal_Address_3"
                        required
                        :readonly="view"
                        :rules="[
                          v => v ? (v && v.length <= 30) || 'field must be less than 30 characters' : null
                        ]"
                      ></v-text-field>
                      <v-select
                        filled dense
                        v-model="currentCustodian.Postal_CountryID"
                        :items="allCountries.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                        item-text="CountryName"
                        item-value="CountryId"
                        label="Country"
                        :readonly="view"
                        :rules="TextFieldRules"
                      ></v-select>
                      <v-select
                        filled dense
                        v-model="currentCustodian.Postal_CityID"
                        :items="allCities.filter(a => a.CountryId == currentCustodian.Postal_CountryID && a.CheckerID != 0 && a.RejectionID == 0)"
                        item-text="City"
                        item-value="CityID"
                        label="City"
                        :readonly="view"
                        :rules="TextFieldRules"
                      ></v-select>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-text-field
                      light dense filled
                      color="#2A353D"
                      v-model="currentCustodian.Telephone"
                      label="Cell/Telephone"
                      required
                      :readonly="view"
                      type="number"
                      :rules="[
                        v => !!v || 'field is required',
                        v => (v && v.length <= 30) || 'field must be less than 30 characters'
                      ]"
                    ></v-text-field>
                    <v-text-field
                      light dense filled
                      color="#2A353D"
                      v-model="currentCustodian.Email"
                      label="Email"
                      :readonly="view"
                      required
                      :rules="emailRules"
                    ></v-text-field>
                    <v-text-field
                      light dense filled
                      color="#2A353D"
                      v-model="currentCustodian.Fax"
                      label="Fax"
                      required
                      :readonly="view"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <span class="d-flex flex-row my-4">
                  <v-spacer/>
                  <v-btn @click="e1 = 1" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-left</v-icon></v-btn>
                  <v-btn class="mx-2" @click="validateStep_2()" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-right</v-icon></v-btn>
                  <v-btn class="white--text" small color="#2A353D" @click="view = false; closeEdit()">close</v-btn>
                </span>
              </v-form>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-form ref="step_3" v-model="step3_valid" lazy-validation elevation="12">
                <v-data-table
                  :headers="contact_headers"
                  :fixed-header="true"
                  :items="currentCustodian.contacts"
                  disable-pagination
                  hide-default-footer dense
                  class="elevation-12 my-allocations-table mt-3"
                >

                  <template v-slot:top >
                    <v-toolbar dense flat>
                      <v-toolbar-title class="grey--text caption font-weight-normal">Contacts</v-toolbar-title>
                      <v-spacer/>
                      <v-btn v-if="!view" class="text-right" @click="NewContact(currentCustodian.contacts)" x-small dark outlined fab color="#2A353D">
                        <v-icon small >mdi-plus</v-icon>
                      </v-btn>
                    </v-toolbar>
                  </template>

                  <template v-slot:item.Contact="{ item }">
                    <v-text-field
                      v-model="item.Contact"
                      label="Name"
                      :rules="TextFieldRules"
                      single-line
                      :readonly="view"
                    ></v-text-field>
                  </template>

                  <template v-slot:item.ContactNumber="{ item }">
                    <v-text-field
                      v-model="item.ContactNumber"
                      label="Cell/Telephone"
                      type="number"
                      :rules="TextFieldRules"
                      single-line
                      :readonly="view"
                    ></v-text-field>
                  </template>

                  <template v-slot:item.Email="{ item }">
                    <v-text-field
                      v-model="item.Email"
                      label="Email"
                      :rules="emailRules"
                      single-line
                      :readonly="view"
                    ></v-text-field>
                  </template>

                  <template v-slot:item.IsPrimaryContact="{ item }">
                    <v-simple-checkbox
                      v-model="item.IsPrimaryContact"
                      :readonly="view"
                    ></v-simple-checkbox>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-icon v-if="!view" small @click="removeContact(item, currentCustodian.contacts)">mdi-close</v-icon>
                  </template>
                </v-data-table>

                <span class="d-flex flex-row my-4 pt-7">
                  <v-spacer/>
                  <v-btn @click="e1 = 2" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-left</v-icon></v-btn>
                  <v-btn class="mx-2" disabled outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-right</v-icon></v-btn>
                  <v-btn class="white--text" small color="#2A353D" @click="view = false; closeEdit()">close</v-btn>
                  <v-btn class="white--text ml-3" v-if="!view" small color="#2A353D" :disabled="!valid" @click="update()">
                    <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    save
                  </v-btn>
                </span>
              </v-form>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-form>
      <v-container row>
        <v-text-field
          class="ml-3"
          hide-details
          outlined
          placeholder="search..."
          v-model="search"
          append-icon="mdi-magnify"
          dense
        ></v-text-field>

        <v-spacer></v-spacer>

        <v-btn v-if="showCreateBtn == true" v-show="confirmedCustodians" @click="showCreate(); closeEdit()" outlined small color="#2A353D" class="ml-2">
          Create New<v-icon small>mdi-plus</v-icon>
        </v-btn>
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" v-if="confirmedCustodians" outlined small color="#2A353D" class="ml-2">
            EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item class="ma-0 pa-0">
            <v-btn @click="generatePDF(false)" text small color="#2A353D">
              <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "xls"
                name    = "Custodians.xls">
  
                <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
              </download-excel>
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "csv"
                name    = "Custodians.csv">
  
                <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
              </download-excel>
            </v-btn>
          </v-list-item>
          </v-list>
        </v-menu>
        <v-btn @click="generatePDF(true)" v-if="confirmedCustodians" outlined small color="#2A353D" class="ml-2" v-on="on">
          PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
        </v-btn>
        <v-btn v-if="!confirmedCustodians" @click="confirmedCustodians = true" outlined small color="#2A353D" class="ml-2" v-on="on">
          ALL RECORDS<v-icon class="ml-1">mdi-playlist-check</v-icon>
        </v-btn>
      </v-container>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-tooltip v-if="!confirmedCustodians && item.CheckerID == 0" top>
        <template v-slot:activator="{ on }">
        <v-btn
          small @click="setActiveCustodian(item, index); updateStatus()"
          outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
          v-on="on"
          color="#2A353D" class="mr-3"
        >
          <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
          confirm<v-icon class="ml-1" color="#2A353D">mdi-check-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>confirm</span>
      </v-tooltip>
      <v-tooltip v-if="!confirmedCustodians && item.CheckerID == 0" top>
        <template v-slot:activator="{ on }">
        <v-btn
          small @click="setActiveCustodian(item, index); rejectionDialog = true"
          outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
          v-on="on"
          color="#2A353D" class="mr-3"
        >
          reject<v-icon class="ml-1" color="#2A353D">mdi-close-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>reject</span>
      </v-tooltip>
      <v-btn
        v-show="confirmedCustodians"
        small outlined :disabled="edit" v-if="item.CheckerID == 0? item.MakerID == currentUser.SecurityUserID : showEditBtn == true"
        @click="setActiveCustodian(item, index); showEdit(); closeCreate()"
        color="#2A353D" class="mr-3"
      >
        <span>edit</span>
      </v-btn>
      <v-btn
        small outlined
        :disabled="edit"
        @click="view = true; setActiveCustodian(item, index); showEdit(); closeCreate()"
        color="#2A353D" class="mr-3"
      >
        <span>view</span>
      </v-btn>
      <v-icon
        :disabled="item.MakerID == currentUser.SecurityUserID && item.CheckerID == 0 ? false : true"
        color="#2A353D" @click="setActiveCustodian(item, index); deleteDialog = true"
      >
       mdi-trash-can-outline
      </v-icon>
    </template>

    <template v-slot:item.ProfileType="{ item }">
      {{ allProfileTypes.filter(a => a.ProfileTypeID == item.ProfileType).map(a => a.ProfileType)[0] }}
    </template>

    <template v-slot:item.status="{ item }">
      <v-chip outlined small color="error" v-if="item.RejectionID !== 0">rejected</v-chip>
      <v-chip outlined small color="warning" v-if="item.CheckerID == 0">pending</v-chip>
      <v-chip outlined dark small color="#A6D879" v-if="item.CheckerID !== 0 && item.RejectionID == 0">confirmed</v-chip>
    </template>

  </v-data-table>
</v-container>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import UserService from '../services/user.service';
import jsPDF from 'jspdf';
import 'jspdf-autotable'

export default {
  data () {
    return {
      confirmedCustodians: true,
      edit: false,
      create: false,
      view: false,
      rejectionDialog: false,
      deleteDialog: false,
      loading: false,
      permitted: null,
      permitted_dialog: true,
      RejectionStatus: 0,
      message: '',
      search: '',
      step1_valid: true,
      step2_valid: true,
      step3_valid: true,
      content: '',
      e1: 1,
      currentCustodian: null,
      currentIndex: -1,
      CurrentDataset: [],
      headers: [
        {
          text: 'Custodian Code',
          align: 'start',
          sortable: true,
          value: 'CustodianCode'
        },
        { text: 'Name', value: 'CustodianName', sortable: false },
        { text: 'Profile Type', value: 'ProfileType', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { value: 'actions', sortable: false, align: 'end' },
      ],
      contact_headers: [
        {
          text: 'Contact',
          align: 'start',
          sortable: true,
          value: 'Contact'
        },
        { text: 'Contact Number', value: 'ContactNumber', sortable: false },
        { text: 'Email', value: 'Email', sortable: false },
        { text: 'Primary Contact', value: 'IsPrimaryContact', sortable: false },
        { value: 'actions', sortable: false, align: 'end' },
      ],
      TextFieldRules: [
        v => !!v || 'field is required',
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        v => (v && v.length <= 100) || 'field must be less than 100 characters'
      ],
      custodian: {
        IsExternal: true,
        contacts: []
      },
      submitted: false,
    }
  },

  computed: {
    ...mapGetters([
      "allCustodians",
      "allProfileTypes",
      "allRejectionReasons",
      "allUsers",
      "allCustodianStatuses",
      "allCities",
      "allCountries",
      "allConfirmationSettings"
    ]),
    currentUser() {
      return this.$store.state.auth.user;
    },

    valid() {
      if (this.step1_valid == true && this.step2_valid == true && this.step3_valid == true){
        return true
      } else {
        return false
      }
    },

    showDeleteBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 3026).map(r => r.AllowDelete)) == 1){
        return true
      }
    }
    return false;
    },

    showEditBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 3026).map(r => r.AllowEdit)) == 1){
        return true
      }
    }
    return false;
    },

    showCreateBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 3026).map(r => r.AllowCreate)) == 1){
        return true
      }
    }
    return false;
    },

    showConfirmBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 3026).map(r => r.AllowConfirm)) == 1){
        return true
      }
    }
    return false;
    },

    CheckerID(){
      if(this.allConfirmationSettings.filter(a => a.FunctionID == 3026).map(a => a.Status)[0] == false){
        return this.currentUser.SecurityUserID
      } else {
        return 0
      }
    }
  },

  methods: {
    ...mapActions([
      "createCustodian",
      "updateCustodian",
      "deleteCustodian"
    ]),

    async createNew() {
      this.message = '';
      await this.validateStep_3();
      if(this.step3_valid == true){
        this.loading = true;
        this.custodian.MakerID = this.currentUser.SecurityUserID,
        this.custodian.CheckerID = this.CheckerID,
        this.custodian.LastUserID = this.currentUser.SecurityUserID,
        this.createCustodian(this.custodian)
        .then(response =>{
          this.$socket.client.emit('socketreq', {
            commit: 'newCustodian',
            data: response.data
          });
          this.message = response.data.message
          this.loading = false;
          this.closeCreate()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false;
        })        
      }
    },

    async update() {
      this.message = '';
      await this.validateStep_3();
      if(this.step3_valid == true){
        this.loading = true;
        if(this.currentCustodian.CheckerID == 0){
          this.currentCustodian.LastUserID = this.currentUser.SecurityUserID,
          this.currentCustodian.RejectionID = this.RejectionStatus,
          this.currentCustodian.CheckerID = 0,
          this.currentCustodian.CheckDate = null,

          this.updateCustodian(this.currentCustodian)
          .then(response => {
            this.$socket.client.emit('socketreq', {
              commit: 'updCustodian',
              data: this.currentCustodian
            });
            
            this.message = response.data.message
            this.loading = false;
            this.closeEdit()
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
            this.loading = false;
          })
        } else {
          this.currentCustodian.MakerID = this.currentUser.SecurityUserID
          this.currentCustodian.LastUserID = this.currentUser.SecurityUserID,
          this.currentCustodian.RejectionID = this.RejectionStatus,
          this.currentCustodian.CheckerID = 0,
          this.currentCustodian.CheckDate = null,
          this.currentCustodian.MakeDate = new Date(),

          this.updateCustodian(this.currentCustodian)
          .then(response => {
            this.$socket.client.emit('socketreq', {
              commit: 'updCustodian',
              data: this.currentCustodian
            });
            
            this.message = response.data.message
            this.loading = false;
            this.closeEdit()
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
            this.loading = false;
          })
        }
      }
    },

    deleteItem() {
      this.message = '';
      this.loading = true;

      this.deleteCustodian(this.currentCustodian)
      .then(response => {
        this.$socket.client.emit('socketreq', {
          commit: 'dltCustodian',
          data: this.currentCustodian
        });
        
        this.message = response.data.message
        this.loading = false;
        this.deleteDialog = false
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
        this.loading = false;
      })
    },

    updateStatus() {
      this.message = '';
      this.loading = true;

      this.currentCustodian.CheckerID = this.currentUser.SecurityUserID,
      this.currentCustodian.LastUserID = this.currentUser.SecurityUserID,
      this.currentCustodian.RejectionID = this.RejectionStatus,
      this.currentCustodian.CheckDate = new Date(),
      this.currentCustodian.updatedAt = new Date(),

      this.updateCustodian(this.currentCustodian)
      .then(response => {
        this.$socket.client.emit('socketreq', {
          commit: 'updCustodian',
          data: this.currentCustodian
        });
        
        this.message = response.data.message
        this.loading = false;
        this.RejectionStatus = 0
        this.rejectionDialog = false
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
        this.loading = false;
      })
    },

    generatePDF(IsPrint) {
      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text("Custodians", 0.5, 0.5);
          // create a line under heading 
          doc.setLineWidth(0.01).line(0.5, 0.6, 8.0, 0.6);
          doc.setLineWidth(0.01).line(0.5, 0.8, 8.0, 0.8);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "potrait",
        unit: "in",
        format: "letter"
      });

      doc.setFont('helvetica');
      doc.setFontSize(5);
      doc.autoTable({
        body: this.CurrentDataset,
        margin: { left: 0.5, top: 0.6 },
        styles: {overflow: 'linebreak',
                fontSize: 6},
        showHeader: 'everyPage',
        theme: 'plain'
      });
      addFooters(doc);
      if(IsPrint == true){
        doc.output('dataurlnewwindow');
      } else{
        doc.save('Custodians.pdf')
      }
    },

    NewContact(item) {
      item.push(
        {
          Contact: '',
          ContactNumber: null,
          Email: '',
          IsPrimaryContact: false,
        }
      )
    },

    removeContact(item, parent) {
      const index = parent.findIndex(p => p.Contact === item.Contact && p.ContactNumber === item.ContactNumber);
      parent.splice(index, 1)
    },

    getFiltered(current){
      this.CurrentDataset = current;
    },

    unconfirmed() {
      this.confirmedCustodians = false
    },

    showEdit () {
      this.edit = true;
      this.e1 = 1
    },

    closeEdit() {
      this.edit = false
    },

    showCreate () {
      this.create = true;
      this.e1 = 1
    },

    closeCreate() {
      this.custodian = {
        IsExternal: true,
        contacts: []
      };
      this.create = false
    },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },

    async validateStep_1(){
      await this.$refs.step_1.validate()
        if(this.step1_valid == true){
          this.e1 = 2
        }
      return this.step1_valid
    },

    async validateStep_2(){
      await this.$refs.step_2.validate()
        if(this.step2_valid == true){
          this.e1 = 3
        }
      return this.step2_valid
    },

    async validateStep_3(){
      await this.$refs.step_3.validate()
      return this.step3_valid
    },

    reset () {
      this.$refs.step_1.reset(),
      this.$refs.step_2.reset(),
      this.$refs.step_3.reset(),

      this.valid = true
    },

    setActiveCustodian (item, index) {
      this.currentCustodian = item
      this.currentIndex = index
    },
  },

  mounted () {
    UserService.isCustodians().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
    this.$root.$on("unconfirmedCustodians", () => {
      this.unconfirmed();
    });
  }
}
</script>

<style scoped>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.v-btn {
  outline: none
}

.edit {
  background-color: #DBEFFA;
}

.headline {
  color:white
}
</style>
